var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',{attrs:{"title":_vm.$t('general.login_as_exhibitor'),"click-action":_vm.clickAction}},[_c('b-icon',{attrs:{"icon":"person-fill"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }